/*
 * buy-button-note.js
 *
 * Scales the Pre-Order note ("Dispatches From 3rd August") so its text fills the
 * full width of the product info column, edge to edge.
 *
 * CSS cannot do this -- fitting text to a box requires measuring the rendered ink
 * width, so it has to be done in JS. Without JS the note simply renders at the 12px
 * fallback size defined in component-preorder.css.
 *
 * Bounds are read from CSS custom properties on .buy-button-note so they can be
 * tuned without touching this file:
 *   --buy-note-min-size  (default 10px)  -- below this, the text wraps instead
 *   --buy-note-max-size  (default 40px)  -- never scale beyond this
 */
(function () {
  if (window.__buyButtonNoteFitter) return;
  window.__buyButtonNoteFitter = true;

  var FALLBACK_MIN = 10;
  var FALLBACK_MAX = 40;

  function readBound(el, prop, fallback) {
    var raw = getComputedStyle(el).getPropertyValue(prop).trim();
    var n = parseFloat(raw);
    return isNaN(n) ? fallback : n;
  }

  // Width of the actual glyphs, not the block box. A <p> is block-level, so its
  // offsetWidth/scrollWidth equals the container width and tells us nothing.
  function inkWidth(el) {
    var range = document.createRange();
    range.selectNodeContents(el);
    var rect = range.getBoundingClientRect();
    range.detach && range.detach();
    return rect.width;
  }

  function fitOne(note) {
    if (!note || note.classList.contains('hidden')) return;

    var available = note.clientWidth;
    if (!available) return;

    var min = readBound(note, '--buy-note-min-size', FALLBACK_MIN);
    var max = readBound(note, '--buy-note-max-size', FALLBACK_MAX);

    var targets = note.querySelectorAll('.buy-button-note__text, p');
    if (!targets.length) return;

    Array.prototype.forEach.call(targets, function (el) {
      el.style.display = 'block';
      el.style.whiteSpace = 'nowrap';
      el.style.lineHeight = '1.2';

      // Measure at the minimum, then scale up proportionally.
      el.style.fontSize = min + 'px';
      var w = inkWidth(el);
      if (!w) return;

      var size = min * (available / w);

      // letter-spacing is absolute (-0.22px) and does not scale with font-size,
      // so a single proportional pass overshoots slightly. One correction pass
      // gets us within a fraction of a pixel.
      if (size > min) {
        el.style.fontSize = Math.min(size, max) + 'px';
        w = inkWidth(el);
        if (w > 0) size = parseFloat(el.style.fontSize) * (available / w);
      }

      if (size <= min) {
        // Text is already too wide at the smallest allowed size: let it wrap
        // rather than overflow the column.
        el.style.fontSize = min + 'px';
        el.style.whiteSpace = 'normal';
      } else {
        el.style.fontSize = Math.min(size, max) + 'px';
      }
    });
  }

  var scheduled = false;
  function fitAll() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      document.querySelectorAll('.buy-button-note').forEach(fitOne);
    });
  }

  function observe(note) {
    if (note.__fitObserved) return;
    note.__fitObserved = true;

    // product-info.js swaps this element's innerHTML on variant change.
    new MutationObserver(fitAll).observe(note, { childList: true, subtree: true });

    if ('ResizeObserver' in window) {
      var lastWidth = 0;
      new ResizeObserver(function (entries) {
        var w = entries[0].contentRect.width;
        if (Math.abs(w - lastWidth) < 1) return; // ignore height-only changes we caused
        lastWidth = w;
        fitAll();
      }).observe(note);
    }
  }

  function init() {
    document.querySelectorAll('.buy-button-note').forEach(observe);
    fitAll();
    // Web fonts change metrics after first paint.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', fitAll);
})();
